module.exports = __webpack_public_path__ + "static/media/add-to-calendar.0b3148be.svg";